/**
 * Permission implications — mirror of backend
 * `src/modules/core/role/role-context.ts → PERMISSION_IMPLICATIONS`.
 *
 * Keep this list in sync with the backend. Holding `when` automatically
 * grants every entry in `grants`. Used by `AuthContext.hasPermission` so
 * UI gates match what the API will actually allow.
 *
 * Only add an entry when a feature genuinely cannot function without the
 * implied read (e.g. creating an EPC project needs to populate customer /
 * location / project-type dropdowns).
 */
export const PERMISSION_IMPLICATIONS: ReadonlyArray<{
  when: string;
  grants: ReadonlyArray<string>;
}> = [
  {
    when: 'epcProject.create',
    grants: ['customerMaster.read', 'locationsMaster.read', 'projectType.read'],
  },
  {
    when: 'epcProject.update',
    grants: ['customerMaster.read', 'locationsMaster.read', 'projectType.read'],
  },
];
